<div class="mb-3">
    <label class="form-label">{{label}}</label>
    <input [type]="type" class="form-control" [ngClass]="{'is-invalid': messageError, 'is-valid': messageSuccess}"
        [placeholder]="placeholder" [(ngModel)]="inputval" (input)="onInputChange()" [disabled]="disabled" [required]="required" [readOnly]="readonly"/>
    <div class="invalid-feedback" *ngIf="messageError">
        {{messageError}}
    </div>
    <div class="valid-feedback" *ngIf="messageSuccess">
        {{messageSuccess}}
    </div>
</div>